// extracted by mini-css-extract-plugin
module.exports = {"container":"MinimalLayout_container__oI-ip","content":"MinimalLayout_content__XqoPt","safeMargin":"MinimalLayout_safeMargin__2TwJX"};